<template>
  <div>
    <v-app-bar
      app
      dense
      tile
      style="
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 5px;
        backdrop-filter: blur(5px);
        box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.1);
      "
    >
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click.stop="switchDrawer(true)"
      ></v-app-bar-nav-icon>
      <v-icon v-if="$vuetify.breakpoint.smAndUp" x-large>mdi-menu-right</v-icon>
      <v-toolbar-title
        v-if="$vuetify.breakpoint.smAndUp"
        class="hidden-xs mx-2 cabecera black--text"
        >{{ this.rutaActual }}</v-toolbar-title
      >
      <v-spacer></v-spacer>

      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-btn
          v-for="(btn, i) in btnsRender"
          v-bind="btn.props"
          small
          depressed
          :to="btn.to"
          :key="'btn-toolbar-' + i"
          active-class="no-active"
        >
          <v-icon left :color="btn.iconColor">{{ btn.icon }}</v-icon>
          {{ btn.text }}
        </v-btn>
      </template>
      <v-menu v-else bottom left offset-x>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon text v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(btn, i) in btnsRender"
            :key="'btn-toolbar-menu-' + i"
            class="px-1"
          >
            <v-btn
              v-bind="btn.props"
              depressed
              :to="btn.to"
              active-class="no-active"
            >
              <v-icon left :color="btn.iconColor">{{ btn.icon }}</v-icon>
              {{ btn.text }}
            </v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      btns: [
        {
          icon: "mdi-account-lock",
          text: "Cambiar Clave",
          to: "/cuenta/cambiar-clave",
          props: {
            text: true
          },
          iconColor: "primary",
          xs: 3
        },
        {
          icon: "mdi-file-certificate",
          text: "Certificado Socio",
          to: "/cuenta/certificado-socio",
          props: {
            text: true
          },
          iconColor: "primary",
          xs: 2
        },
        {
          icon: "mdi-account-credit-card",
          text: "Pagar Productos",
          to: { name: "pagoweb" },
          props: {
            color: "#11324A",
            rounded: true,
            class: "white--text"
          },
          xs: 1
        }
      ]
    };
  },
  computed: {
    ...mapState(["rutaActual"]),

    btnsRender() {
      const btns = [].concat(this.btns);
      if (this.$vuetify.breakpoint.xs) return btns.sort((a, b) => a.xs - b.xs);
      else return btns;
    }
  },
  methods: {
    ...mapActions(["switchDrawer"])
  }
};
</script>

<style scoped lang="css">
.cabecera {
  font-weight: 300;
  font-size: 20px;
  line-height: 25px;
}
.v-btn--active.no-active::before {
  display: none;
}
</style>
